// extracted by mini-css-extract-plugin
module.exports = {"ldsHourglass":"style-module--lds-hourglass--3AcCa"};